import React, { useEffect, useState } from "react";
import EmptyState from "../../reusableComponents/ConfigEmptyState/EmptyState";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import "./recon.css";
import SmallModal from "../../reusableComponents/modals/SmallModal";
import UploadFileModal from "./UploadFileModal";
import { useAuth } from "../../context/API_Client";
import { currentTimeInTimezone } from "../utils/utils";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import BoxPayGrid from "../BoxPayGrid";
import { ReconSchema } from "./ReconSchema";
import { reconFiltersSchema } from "./ReconFiltersSchema";
import Filter from "../filters/filter";
import LoadingLogoPage from "../loadingPage/loadingPage";
import { fortmatTimezoneToUTC } from "../utils/utils";
import ExclamationCircleIcon from "../../../assets/svg/ExclamationCircleLightBlue.svg";
import { fileCopyDefaultColor } from "../../reusableComponents/constants";
import { colorBrandObject } from "../../../constants/brandings";

const Recon = (operationPermissions) => {
  const {
    postPspConfigForFiltering,
    getReconSampleFile,
    postReconFile,
    merchantSettings,
    postSettlementFiles,
    getAllPspConfigs,
    getReconConflictFile,
    handleApiError,
    getSupportedPspRecon,
  } = useAuth();
  const [processors, setProcessors] = useState([]);
  const [optionsToDisplay, setOptionsToDisplay] = useState([]);
  const [optionsToSend, setOptionsToSend] = useState([]);
  const [selectedProcessor, setSelectedProcessor] = useState();
  const [toggleDownloadModal, setToggleDownloadModal] = useState(false);
  const [
    toggleUploadProcessorSelectModal,
    setToggleUploadProcessorSelectModal,
  ] = useState(false);
  const [toggleUploadModal, setToggleUploadModal] = useState(false);
  const [allFilesData, setAllFilesData] = useState([]);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [withoutSearchbarModalData, setWithoutSearchbarModalData] = useState(
    []
  );



  const [withSearchbarModalData, setWithSearchbarModalData] = useState([]);
  const [dateModalData, setDateModalData] = useState([]);
  const [timeZone, setTimezone] = useState();
  const [pspData, setPspData] = useState();
  const [loading, setLoading] = useState(false);
  const [uploadFileErrors, setUploadFileErrors] = useState();
  const [operationStatuses, setOperationStatuses] = useState([]);
  const [pspCodes, setPspCodes] = useState([]);

  // API call to show processors in dropdown
  useEffect(() => {
    postPspConfigForFiltering(
      {},
      (data) => {
        updateAllPspAndCurrencySchemaArray(
          reconFiltersSchema,
          "processor",
          data?.pspCodes
        );
        updateAllPspAndCurrencySchemaArray(
          reconFiltersSchema,
          "metadata.SETTLEMENT_CURRENCY",
          data?.currencyCodes
        );
        setProcessors(data?.pspCodes);
      },
      (errMsg) => {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  // API call to load pspData
  useEffect(() => {
    getAllPspConfigs(
      function (pspData) {
        setPspData(pspData);
        getSupportedPspRecon(
          (data) => {
            setPspCodes(data?.pspCodes)
            setOperationStatuses(data?.operationStatuses);
            for (let i = 0; i < data?.pspCodes?.length; i++) {
              optionsToDisplay.push(data?.pspCodes[i]?.title);
              optionsToSend.push(data?.pspCodes[i]?.value);
              if (optionsToSend?.length > 0) {
                setSelectedProcessor(optionsToSend[0]);
                setOptionsToDisplay(optionsToDisplay);
                setOptionsToSend(optionsToSend);
              }
            }
          },
          (errMsg) => { }
        );
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  // API call for timeZone
  useEffect(() => {
    merchantSettings(
      function (merchantData) {
        setTimezone(merchantData?.timeZone);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  useEffect(() => {
    if (timeZone && pspData) {
      setLoading(true);
      getFileData();
    }
  }, [
    timeZone,
    pspData,
    withoutSearchbarModalData,
    withSearchbarModalData,
    dateModalData,
  ]);

  const getFileData = () => {
    let filters = {};
    withoutSearchbarModalData.forEach((item) => {
      filters[item?.id] = item?.value;
    });
    withSearchbarModalData.forEach((item) => {
      filters[item?.id === "processor" ? "metadata.pspCode" : item?.id] = item?.value;
    });
    if (timeZone) {
      let payload = {
        attributeFilters: filters,
        limit: 100,
      };

      let fromDate, toDate;
      if (dateModalData?.finalStartDate && dateModalData?.finalEndDate) {
        const { fromDate: formattedFromDate, toDate: formattedToDate } =
          fortmatTimezoneToUTC(
            dateModalData?.selectedValue,
            dateModalData?.finalStartDate,
            dateModalData?.finalEndDate
          );
        fromDate = formattedFromDate;
        toDate = formattedToDate;
        payload["advancedAttributeFilters"] = [
          {
            attrName: "metadata.settlementDate",
            operator: "gte",
            values: [fromDate],
          },
          {
            attrName: "metadata.settlementDate",
            operator: "lte",
            values: [toDate],
          },
        ];
      }

      postSettlementFiles(payload, (data) => {
        const filesDataPoints = data?.points;
        filesDataPoints.map((dataPoint) => {
          dataPoint.pspInfo = pspData.find(
            (psp) => psp?.pspCode === dataPoint?.metadata?.pspCode
          );
        });
        setLoading(false);
        setAllFilesData(filesDataPoints);
      },
        (errMsg) => {
          setLoading(false);
          customToast("error", "high", errMsg);
        }
      );
    }
  };

  // filter functions
  const updateAllPspAndCurrencySchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData?.findIndex((obj) => obj?.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };

  const handleWithoutSearchbarModalData = (data) => {
    setWithoutSearchbarModalData(data);
  };

  const handleSearchbarModalData = (data) => {
    setWithSearchbarModalData(data);
  };

  const handleDateModalData = (data) => {
    setDateModalData(data);
  };

  const handleCloseDownloadProcessorModal = () => {
    setToggleDownloadModal(false);
  };

  const handleOpenDownloadProcessorModal = () => {
    setSelectedProcessor(optionsToSend[0]);
    setToggleDownloadModal(true);
  };

  const handleCloseUploadProcessorModal = () => {
    setToggleUploadProcessorSelectModal(false);
  };

  const handleOpenUploadProcessorModal = () => {
    setSelectedProcessor(optionsToSend[0]);
    setToggleUploadProcessorSelectModal(true);
  };

  const handleCloseUploadModal = () => {
    setUploadFileErrors(null);
    setToggleUploadModal(false);
  };

  const handleOpenUploadModal = () => {
    handleCloseUploadProcessorModal();
    setUploadFileErrors(null);
    setToggleUploadModal(true);
  };

  const handleProcessorSelect = (id, value) => {
    setSelectedProcessor(value);
  };

  // API to download sample file
  const handleDownload = () => {
    getReconSampleFile(
      selectedProcessor,
      (data) => {
        customToast("success", "high", "Download successful");
        handleCloseDownloadProcessorModal();
      },
      (errMsg) => {
        customToast(
          "error",
          "high",
          errMsg ? errMsg : "Unexpected error occured. Try again later."
        );
      }
    );
  };

  // API to upload recon file
  const handleUpload = (fileData) => {
    setUploadingFile(true);
    const formData = new FormData();
    formData.append("file", fileData);
    postReconFile(
      selectedProcessor,
      formData,
      (data) => {
        setLoading(true);
        customToast("success", "high", "Upload successful");
        handleCloseUploadModal();
        setTimeout(function () {
          getFileData();
        }, 3000);

        setUploadingFile(false);
      },
      (err) => {
        if (err?.response?.status === 415 || err?.response?.status === 400) {
          setUploadFileErrors(err);
          setUploadingFile(false);
        } else {
          handleApiError(err, (errMsg) =>
            customToast(
              "error",
              "high",
              errMsg ? errMsg : "Unexpected error occured. Try again later."
            )
          );
          handleCloseUploadModal();
          setUploadingFile(false);
        }
      }
    );
  };

  const resetUploadData = () => {
    setUploadingFile(false);
    setUploadFileErrors(false);
  };

  const handleDonwnloadConflictFile = (fileId) => {
    getReconConflictFile(
      fileId,
      (data) => {
        customToast("success", "high", "Download successful");
      },
      (errMsg) => {
        customToast(
          "error",
          "high",
          errMsg ? errMsg : "Unexpected error occured. Try again later."
        );
      }
    );
  };

  return (
    <>
      <div className="content-wrapper" style={{ background: "white" }}>
        <section className="content">
          {toggleUploadModal && (
            <UploadFileModal
              outlinedBtnText={"Cancel"}
              filledBtnText={"Upload"}
              outlinedBtnFunction={handleCloseUploadModal}
              filledBtnFunction={(data) => handleUpload(data)}
              toggleDialog={toggleUploadModal}
              icon={
                <img src="/assets/orderDetailsIcons/ExclamationCircle-light-blue.svg" />
              }
              handleUpload={handleUpload}
              uploadingFile={uploadingFile}
              uploadFileErrors={uploadFileErrors}
              uploadAgain={resetUploadData}
            />
          )}
          <SmallModal
            headerText={"Select your processor"}
            subHeaderText={
              "Select the processor which you want to download the sample reconciliation file"
            }
            outlinedBtnText={"Cancel"}
            filledBtnText={"Download"}
            outlinedBtnFunction={() => handleCloseDownloadProcessorModal()}
            filledBtnFunction={handleDownload}
            toggleDialog={toggleDownloadModal}
            icon={
              <div style={{ stroke: fileCopyDefaultColor }}>
                <ExclamationCircleIcon stroke={`${colorBrandObject?.primaryButtonColor}`} />
              </div>
            }
            type={"secondary"}
            dropdownData={{
              optionsToDisplay: optionsToDisplay,
              optionsToSend: optionsToSend,
              dropdownId: processors,
              defaultValue: optionsToDisplay[0],
              updateDropdownSelect: handleProcessorSelect,
            }}
          />
          <SmallModal
            headerText={"Select your processor"}
            subHeaderText={"Select the processor which you want to reconcile"}
            outlinedBtnText={"Cancel"}
            filledBtnText={"Next"}
            type={"secondary"}
            outlinedBtnFunction={handleCloseUploadProcessorModal}
            filledBtnFunction={handleOpenUploadModal}
            toggleDialog={toggleUploadProcessorSelectModal}
            icon={
              <div style={{ stroke: fileCopyDefaultColor }}>
                <ExclamationCircleIcon stroke={`${colorBrandObject?.primaryButtonColor}`} fill={`${colorBrandObject?.primaryButtonColor}`} />
              </div>
            }
            dropdownData={{
              optionsToDisplay: optionsToDisplay,
              optionsToSend: optionsToSend,
              dropdownId: processors,
              defaultValue: optionsToDisplay[0],
              updateDropdownSelect: handleProcessorSelect,
            }}
          />
          <div className="recon-root">
            {allFilesData?.length === 0 &&
              withoutSearchbarModalData?.length === 0 &&
              withSearchbarModalData?.length == 0 &&
              dateModalData?.length === 0 &&
              loading ? (
              <LoadingLogoPage />
            ) : allFilesData?.length <= 0 &&
              withoutSearchbarModalData?.length === 0 &&
              withSearchbarModalData?.length == 0 &&
              dateModalData?.length === 0 &&
              !loading ? (
              <div className="recon-root-container">
                <EmptyState
                  image={
                    <ShowChartIcon
                      sx={{
                        color: "rgba(201, 201, 204, 1)",
                        height: "120px",
                        width: "120px",
                      }}
                    />
                  }
                  mainText={"Reconciliation"}
                  subText={`Click Upload file to continue with your reconciliation report`}
                  btnText={"Upload file"}
                  secondaryBtnText={"Download sample"}
                  btnFunction={handleOpenUploadProcessorModal}
                  secondaryBtnFunction={handleOpenDownloadProcessorModal}
                  btnPermission={operationPermissions?.uploadSettlementFile}
                />
              </div>
            ) : (
              <>
                <ContentHeader
                  firstHeading="Reconciliation"
                  secondHeading="Get a handle on your reconciliation progress"
                  icon={<ShowChartIcon sx={{ color: colorBrandObject.sideBarSelectedOptionBackground }} />}
                  buttonText="Download Sample"
                  buttonType="primary"
                  buttonSize="md"
                  buttonVariant="outlined"
                  buttonOnclick={handleOpenDownloadProcessorModal}
                  secondaryButtonText="Upload File"
                  secondaryButtonType="primary"
                  secondaryButtonSize="md"
                  secondaryButtonVariant="contained"
                  secondaryButtonOnClick={handleOpenUploadProcessorModal}
                  buttonPermissions={[
                    operationPermissions?.uploadSettlementFile,
                  ]}
                  secondaryButtonPermissions={[
                    operationPermissions?.uploadSettlementFile,
                  ]}
                />
                <div style={{ display: "flex", marginTop: "32px" }}>
                  <Filter
                    value={0}
                    filteredSchema={reconFiltersSchema}
                    pspCodes={pspCodes}
                    handleWithoutSearchbarModalData={
                      handleWithoutSearchbarModalData
                    }
                    handleSearchbarModalData={handleSearchbarModalData}
                    handleDateModalData={handleDateModalData}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "24px",
                    justifyContent: "center",
                    alignItems: "center",
                    height: loading ? "50vh" : "auto",
                  }}
                >
                  {loading ? (
                    <LoadingLogoPage />
                  ) : (
                    <BoxPayGrid
                      schema={ReconSchema(
                        handleDonwnloadConflictFile,
                        operationPermissions,
                        operationStatuses,
                        timeZone
                      )}
                      data={allFilesData}
                      showCustomizeButton={false}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default Recon;
